import { GROUPS, PREFIX } from '@/service/apiConf';
import { get } from '@/service/request';

import type { ModelPlazaListQuery, ModelPlazaListResponse } from './types';

const modelPlazaListUrl = () => `${PREFIX.vapis_dc_ws(GROUPS.ophub)}/artifacts`;

/** 查询当前数据中心/租户上下文下的模型广场列表 */
export function getModelPlazaList(params: ModelPlazaListQuery) {
  return get<ModelPlazaListResponse>(modelPlazaListUrl(), { artifactType: 'model_repo', ...params });
}
